import React, { useState } from "react";
import { toast } from "react-toastify";
import { ApiService } from "../ApiService";
import { useParams } from "react-router-dom";
import { X } from "@mui/icons-material";
import { Alert } from "@mui/material";
import Snackbar from "@mui/material/Snackbar";

export const ModalNuevoCliente = ({ isOpen, onClose, keyBranch }) => {
	const [nombre, setNombre] = useState("");
	const [apellido, setApellido] = useState("");
	const [ci, setCi] = useState("");
	const [codigoPais, setCodigoPais] = useState("+591"); // Código de país predeterminado
	const [imagen, setImagen] = useState(null);
	const [imagenPreview, setImagenPreview] = useState(null);
	const [nombreError, setNombreError] = useState(false);
	const [apellidoError, setApellidoError] = useState(false);
	const [telefonoError, setTelefonoError] = useState(false);
	const [ciError, setCiError] = useState(false);
	const [imagenError, setImagenError] = useState(false);

	// El país seleccionado por defecto será Bolivia (siempre y cuando exista en tu array)

	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [searchTerm, setSearchTerm] = useState("");

	const countries = [
		{ nameCode: "af", dialCode: "93", name: "+93" },
		{ nameCode: "al", dialCode: "355", name: "+355" },
		{ nameCode: "de", dialCode: "49", name: "+49" },
		{ nameCode: "ad", dialCode: "376", name: "+376" },
		{ nameCode: "ao", dialCode: "244", name: "+244" },
		{ nameCode: "ag", dialCode: "1", name: "+1" },
		{ nameCode: "sa", dialCode: "966", name: "+966" },
		{ nameCode: "dz", dialCode: "213", name: "+213" },
		{ nameCode: "ar", dialCode: "54", name: "+54" },
		{ nameCode: "am", dialCode: "374", name: "+374" },
		{ nameCode: "au", dialCode: "61", name: "+61" },
		{ nameCode: "at", dialCode: "43", name: "+43" },
		{ nameCode: "az", dialCode: "994", name: "+994" },
		{ nameCode: "bs", dialCode: "1", name: "+1" },
		{ nameCode: "bd", dialCode: "880", name: "+880" },
		{ nameCode: "bb", dialCode: "1", name: "+1" },
		{ nameCode: "bh", dialCode: "973", name: "+973" },
		{ nameCode: "be", dialCode: "32", name: "+32" },
		{ nameCode: "bz", dialCode: "501", name: "+501" },
		{ nameCode: "bj", dialCode: "229", name: "+229" },
		{ nameCode: "by", dialCode: "375", name: "+375" },
		{ nameCode: "mm", dialCode: "95", name: "+95" },
		{ nameCode: "bo", dialCode: "591", name: "+591" },
		{ nameCode: "ba", dialCode: "387", name: "+387" },
		{ nameCode: "bw", dialCode: "267", name: "+267" },
		{ nameCode: "br", dialCode: "55", name: "+55" },
		{ nameCode: "bn", dialCode: "673", name: "+673" },
		{ nameCode: "bg", dialCode: "359", name: "+359" },
		{ nameCode: "bf", dialCode: "226", name: "+226" },
		{ nameCode: "bi", dialCode: "257", name: "+257" },
		{ nameCode: "bt", dialCode: "975", name: "+975" },
		{ nameCode: "cv", dialCode: "238", name: "+238" },
		{ nameCode: "kh", dialCode: "855", name: "+855" },
		{ nameCode: "cm", dialCode: "237", name: "+237" },
		{ nameCode: "ca", dialCode: "1", name: "+1" },
		{ nameCode: "qa", dialCode: "974", name: "+974" },
		{ nameCode: "td", dialCode: "235", name: "+235" },
		{ nameCode: "cl", dialCode: "56", name: "+56" },
		{ nameCode: "cn", dialCode: "86", name: "+86" },
		{ nameCode: "cy", dialCode: "357", name: "+357" },
		{ nameCode: "va", dialCode: "39", name: "+39" },
		{ nameCode: "co", dialCode: "57", name: "+57" },
		{ nameCode: "km", dialCode: "269", name: "+269" },
		{ nameCode: "kp", dialCode: "850", name: "+850" },
		{ nameCode: "kr", dialCode: "82", name: "+82" },
		{ nameCode: "ci", dialCode: "225", name: "+225" },
		{ nameCode: "cr", dialCode: "506", name: "+506" },
		{ nameCode: "hr", dialCode: "385", name: "+385" },
		{ nameCode: "cu", dialCode: "53", name: "+53" },
		{ nameCode: "dk", dialCode: "45", name: "+45" },
		{ nameCode: "dm", dialCode: "1", name: "+1" },
		{ nameCode: "ec", dialCode: "593", name: "+593" },
		{ nameCode: "eg", dialCode: "20", name: "+20" },
		{ nameCode: "sv", dialCode: "503", name: "+503" },
		{ nameCode: "ae", dialCode: "971", name: "+971" },
		{ nameCode: "er", dialCode: "291", name: "+291" },
		{ nameCode: "sk", dialCode: "421", name: "+421" },
		{ nameCode: "si", dialCode: "386", name: "+386" },
		{ nameCode: "es", dialCode: "34", name: "+34" },
		{ nameCode: "us", dialCode: "1", name: "+1" },
		{ nameCode: "ee", dialCode: "372", name: "+372" },
		{ nameCode: "et", dialCode: "251", name: "+251" },
		{ nameCode: "ph", dialCode: "63", name: "+63" },
		{ nameCode: "fi", dialCode: "358", name: "+358" },
		{ nameCode: "fj", dialCode: "679", name: "+679" },
		{ nameCode: "fr", dialCode: "33", name: "+33" },
		{ nameCode: "ga", dialCode: "241", name: "+241" },
		{ nameCode: "gm", dialCode: "220", name: "+220" },
		{ nameCode: "ge", dialCode: "995", name: "+995" },
		{ nameCode: "gh", dialCode: "233", name: "+233" },
		{ nameCode: "gd", dialCode: "1", name: "+1" },
		{ nameCode: "gr", dialCode: "30", name: "+30" },
		{ nameCode: "gt", dialCode: "502", name: "+502" },
		{ nameCode: "gy", dialCode: "592", name: "+592" },
		{ nameCode: "gn", dialCode: "224", name: "+224" },
		{ nameCode: "gq", dialCode: "240", name: "+240" },
		{ nameCode: "gw", dialCode: "245", name: "+245" },
		{ nameCode: "ht", dialCode: "509", name: "+509" },
		{ nameCode: "hn", dialCode: "504", name: "+504" },
		{ nameCode: "hu", dialCode: "36", name: "+36" },
		{ nameCode: "in", dialCode: "91", name: "+91" },
		{ nameCode: "id", dialCode: "62", name: "+62" },
		{ nameCode: "iq", dialCode: "964", name: "+964" },
		{ nameCode: "ir", dialCode: "98", name: "+98" },
		{ nameCode: "ie", dialCode: "353", name: "+353" },
		{ nameCode: "is", dialCode: "354", name: "+354" },
		{ nameCode: "mh", dialCode: "692", name: "+692" },
		{ nameCode: "sb", dialCode: "677", name: "+677" },
		{ nameCode: "il", dialCode: "972", name: "+972" },
		{ nameCode: "it", dialCode: "39", name: "+39" },
		{ nameCode: "jm", dialCode: "1", name: "+1" },
		{ nameCode: "jp", dialCode: "81", name: "+81" },
		{ nameCode: "jo", dialCode: "962", name: "+962" },
		{ nameCode: "kz", dialCode: "7", name: "+7" },
		{ nameCode: "ke", dialCode: "254", name: "+254" },
		{ nameCode: "kg", dialCode: "996", name: "+996" },
		{ nameCode: "ki", dialCode: "686", name: "+686" },
		{ nameCode: "kw", dialCode: "965", name: "+965" },
		{ nameCode: "la", dialCode: "856", name: "+856" },
		{ nameCode: "ls", dialCode: "266", name: "+266" },
		{ nameCode: "lv", dialCode: "371", name: "+371" },
		{ nameCode: "lb", dialCode: "961", name: "+961" },
		{ nameCode: "lr", dialCode: "231", name: "+231" },
		{ nameCode: "ly", dialCode: "218", name: "+218" },
		{ nameCode: "li", dialCode: "423", name: "+423" },
		{ nameCode: "lt", dialCode: "370", name: "+370" },
		{ nameCode: "lu", dialCode: "352", name: "+352" },
		{ nameCode: "mk", dialCode: "389", name: "+389" },
		{ nameCode: "mg", dialCode: "261", name: "+261" },
		{ nameCode: "my", dialCode: "60", name: "+60" },
		{ nameCode: "mw", dialCode: "265", name: "+265" },
		{ nameCode: "mv", dialCode: "960", name: "+960" },
		{ nameCode: "ml", dialCode: "223", name: "+223" },
		{ nameCode: "mt", dialCode: "356", name: "+356" },
		{ nameCode: "ma", dialCode: "212", name: "+212" },
		{ nameCode: "mu", dialCode: "230", name: "+230" },
		{ nameCode: "mr", dialCode: "222", name: "+222" },
		{ nameCode: "mx", dialCode: "52", name: "+52" },
		{ nameCode: "fm", dialCode: "691", name: "+691" },
		{ nameCode: "md", dialCode: "373", name: "+373" },
		{ nameCode: "mc", dialCode: "377", name: "+377" },
		{ nameCode: "mn", dialCode: "976", name: "+976" },
		{ nameCode: "me", dialCode: "382", name: "+382" },
		{ nameCode: "mz", dialCode: "258", name: "+258" },
		{ nameCode: "na", dialCode: "264", name: "+264" },
		{ nameCode: "nr", dialCode: "674", name: "+674" },
		{ nameCode: "np", dialCode: "977", name: "+977" },
		{ nameCode: "ni", dialCode: "505", name: "+505" },
		{ nameCode: "ne", dialCode: "227", name: "+227" },
		{ nameCode: "ng", dialCode: "234", name: "+234" },
		{ nameCode: "no", dialCode: "47", name: "+47" },
		{ nameCode: "nz", dialCode: "64", name: "+64" },
		{ nameCode: "om", dialCode: "968", name: "+968" },
		{ nameCode: "nl", dialCode: "31", name: "+31" },
		{ nameCode: "pk", dialCode: "92", name: "+92" },
		{ nameCode: "pw", dialCode: "680", name: "+680" },
		{ nameCode: "pa", dialCode: "507", name: "+507" },
		{ nameCode: "pg", dialCode: "675", name: "+675" },
		{ nameCode: "py", dialCode: "595", name: "+595" },
		{ nameCode: "pe", dialCode: "51", name: "+51" },
		{ nameCode: "pl", dialCode: "48", name: "+48" },
		{ nameCode: "pt", dialCode: "351", name: "+351" },
		{ nameCode: "gb", dialCode: "44", name: "+44" },
		{ nameCode: "cf", dialCode: "236", name: "+236" },
		{ nameCode: "cz", dialCode: "420", name: "+420" },
		{ nameCode: "cg", dialCode: "242", name: "+242" },
		{ nameCode: "cd", dialCode: "243", name: "+243" },
		{ nameCode: "do", dialCode: "1", name: "+1" },
		{ nameCode: "za", dialCode: "27", name: "+27" },
		{ nameCode: "rw", dialCode: "250", name: "+250" },
		{ nameCode: "ro", dialCode: "40", name: "+40" },
		{ nameCode: "ru", dialCode: "7", name: "+7" },
		{ nameCode: "ws", dialCode: "685", name: "+685" },
		{ nameCode: "kn", dialCode: "1", name: "+1" },
		{ nameCode: "sm", dialCode: "378", name: "+378" },
		{ nameCode: "vc", dialCode: "1", name: "+1" },
		{ nameCode: "lc", dialCode: "1", name: "+1" },
		{ nameCode: "st", dialCode: "239", name: "+239" },
		{ nameCode: "sn", dialCode: "221", name: "+221" },
		{ nameCode: "rs", dialCode: "381", name: "+381" },
		{ nameCode: "sc", dialCode: "248", name: "+248" },
		{ nameCode: "sl", dialCode: "232", name: "+232" },
		{ nameCode: "sg", dialCode: "65", name: "+65" },
		{ nameCode: "sy", dialCode: "963", name: "+963" },
		{ nameCode: "so", dialCode: "252", name: "+252" },
		{ nameCode: "lk", dialCode: "94", name: "+94" },
		{ nameCode: "sz", dialCode: "268", name: "+268" },
		{ nameCode: "sd", dialCode: "249", name: "+249" },
		{ nameCode: "ss", dialCode: "211", name: "+211" },
		{ nameCode: "se", dialCode: "46", name: "+46" },
		{ nameCode: "ch", dialCode: "41", name: "+41" },
		{ nameCode: "sr", dialCode: "597", name: "+597" },
		{ nameCode: "th", dialCode: "66", name: "+66" },
		{ nameCode: "tz", dialCode: "255", name: "+255" },
		{ nameCode: "tj", dialCode: "992", name: "+992" },
		{ nameCode: "tl", dialCode: "670", name: "+670" },
		{ nameCode: "tg", dialCode: "228", name: "+228" },
		{ nameCode: "to", dialCode: "676", name: "+676" },
		{ nameCode: "tt", dialCode: "1", name: "+1" },
		{ nameCode: "tn", dialCode: "216", name: "+216" },
		{ nameCode: "tm", dialCode: "993", name: "+993" },
		{ nameCode: "tr", dialCode: "90", name: "+90" },
		{ nameCode: "tv", dialCode: "688", name: "+688" },
		{ nameCode: "ua", dialCode: "380", name: "+380" },
		{ nameCode: "ug", dialCode: "256", name: "+256" },
		{ nameCode: "uy", dialCode: "598", name: "+598" },
		{ nameCode: "uz", dialCode: "998", name: "+998" },
		{ nameCode: "vu", dialCode: "678", name: "+678" },
		{ nameCode: "ve", dialCode: "58", name: "+58" },
		{ nameCode: "vn", dialCode: "84", name: "+84" },
		{ nameCode: "ye", dialCode: "967", name: "+967" },
		{ nameCode: "dj", dialCode: "253", name: "+253" },
		{ nameCode: "zm", dialCode: "260", name: "+260" },
		{ nameCode: "zw", dialCode: "263", name: "+263" },
	];

	const bolivia = countries.find((c) => c.nameCode === "bo") || {};
	const [selectedCountry, setSelectedCountry] = useState(bolivia);

	const [phoneNumber, setPhoneNumber] = useState("");

	if (!isOpen) return null;

	const toggleDropdown = (e) => {
		e.stopPropagation(); // Previene propagación si tienes otros eventos
		setDropdownOpen(!dropdownOpen);
	};

	const filteredCountries = countries.filter((country) => {
		const term = searchTerm.toLowerCase();
		return (
			country.dialCode.toLowerCase().includes(term) ||
			country.nameCode.toLowerCase().includes(term) ||
			country.name.toLowerCase().includes(term)
		);
	});

	const handleSelectCountry = (country, e) => {
		e.stopPropagation();
		setSelectedCountry(country);
		setDropdownOpen(false); // Se cierra al seleccionar
		setSearchTerm(""); // Reinicia campo búsqueda
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		const newNombre = String(nombre).trim();
		const newApellido = String(apellido).trim();
		const newTelefono = String(phoneNumber).trim();
		const newCI = String(ci).trim();
		let hasError = false;

		if (!newNombre || newNombre.length < 2) toast.error("El nombre es obligatorio");
		// if((newApellido.length>0 && newApellido.length<2) || !newApellido) {

		if (!newTelefono || newTelefono.length < 7) toast.error("El telefono es obligatorio");

		if (!newCI || newCI.length < 7) toast.error("El documento de identificacion es obligatorio");

		if (!newNombre || newNombre.length < 2 || !newTelefono || newTelefono.length < 7 || !newCI || newCI.length < 7)
			hasError = true;

		if (hasError) return;

		const body_request = {
			firstName: newNombre,
			lastName: newApellido ?? "",
			dni: newCI,
			codeP: "591" || codigoPais,
			phone: newTelefono,
		};

		const response = await ApiService.fetchData(`api/company/clients/create?key_branch=${keyBranch}`, {
			method: "POST",
			body: JSON.stringify(body_request),
		});

		const data = await response;

		if (data && data.message) {
			toast.success(data.message);
		}

		setNombre("");
		setApellido("");
		setPhoneNumber("");
		setCi("");
		onClose();
	};

	return (
		<div className="modal-overlay-old">
			<div className="modal-container-old" id="modal-big">
				<div className="modal-header-old">
					<h2 className="modal-title">Nuevo Cliente</h2>
					<button className="close-modal-btn" onClick={onClose}>
						✖
					</button>
				</div>

				<form onSubmit={handleSubmit}>
					<div className="modal-body" style={{ display: "flex", gap: "20px" }}>
						{/* Sección Izquierda */}
						<div className="modal-left" style={{ flex: 1 }}>
							<div className="form-group">
								<label className="txt-name-category" htmlFor="clienteNombre">
									Nombre / Razón Social<span className="obligate">*</span>
								</label>
								<input
									className={`modal-input-old ${nombreError ? "input-error" : ""}`}
									type="text"
									id="clienteNombre"
									placeholder="Ingrese el nombre"
									value={nombre}
									tabIndex={'1'}
									onChange={(e) => {
										const text_value = String(e.target.value);
										setNombre(text_value);
										setNombreError(text_value.length > 1 ? false : true);
									}}
								/>
							</div>

							<div className="form-group mb-3" style={{ marginBottom: "7px" }}>
								<label className="txt-name-category" htmlFor="phone">
									Teléfono<span className="obligate">*</span>
								</label>

								<div
									className="custom-select-container"
									style={{
										width: "100%",
										display: "flex",
										flexFlow: "row nowrap",
										alignItems: "center",
									}}>
									{/* BOTÓN/ÁREA QUE ABRE/CERRARÁ EL MENÚ */}
									<div
										className="custom-select-code"
										onClick={toggleDropdown}
										style={{
											display: "flex",
											alignItems: "center",
											cursor: "pointer",
											position: "relative",
											background: "white",
											padding: "0 6px",
											border: "1px solid #ccc",
											borderRadius: "4px",
											marginRight: "2px",
											width: "60%",
											height: "40px",
											marginTop: "2px",
										}}>
										{/* Opción Seleccionada (visible siempre) */}
										<div
											className="selected-option"
											style={{
												width: "100%",
												display: "flex",
												flexDirection: "row",
												alignItems: "center",
												justifyContent: "center",
											}}>
											<img
												className="img-bandera"
												src={`/banderas/${selectedCountry.nameCode}.png`}
												alt="bandera"
												style={{
													width: "20px",
													height: "14px",
													marginRight: "5px",
												}}
											/>
											<span>{selectedCountry.dialCode}</span>
										</div>

										{/* MENU DESPLEGABLE */}
										{dropdownOpen && (
											<div
												className="select-options"
												style={{
													position: "absolute",
													top: "100%",
													left: 0,
													right: 0,
													background: "#fff",
													border: "1px solid #ccc",
													boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
													zIndex: 9999,
													maxHeight: "220px",
													overflowY: "auto",
													paddingBottom: "8px",
												}}>
												{/* INPUT PARA BUSCAR */}
												<div style={{ padding: "8px" }}>
													<input
														type="text"
														placeholder="Buscar..."
														value={searchTerm}
														onClick={(e) => e.stopPropagation()}
														onChange={(e) => setSearchTerm(e.target.value)}
														tabIndex={'3'}
														style={{
															width: "100%",
															padding: "6px",
															boxSizing: "border-box",
															marginBottom: "4px",
															border: "1px solid #ddd",
															borderRadius: "4px",
															height: "30px",
															fontSize: "14px",
														}}
													/>
												</div>

												{/* LISTA FILTRADA */}
												{filteredCountries.length === 0 ? (
													<div style={{ padding: "8px", color: "#888" }}>Sin resultados</div>
												) : (
													filteredCountries.map((country) => (
														<div
															key={country.nameCode}
															className="select-option"
															onClick={(e) => handleSelectCountry(country, e)}
															style={{
																display: "flex",
																alignItems: "center",
																padding: "5px 8px",
																cursor: "pointer",
																borderBottom: "1px solid #f0f0f0",
															}}>
															<img
																className="img-bandera"
																src={`/banderas/${country.nameCode}.png`}
																alt="bandera"
																style={{
																	width: "20px",
																	height: "14px",
																	marginRight: "8px",
																}}
															/>
															<span>{country.name}</span>
														</div>
													))
												)}
											</div>
										)}
									</div>

									{/* INPUT NÚMERO TELEFÓNICO */}
									<input
										className={`modal-input-old ${telefonoError ? "input-error" : ""}`}
										type="tel"
										placeholder="Número de teléfono"
										tabIndex={'4'}
										style={{
											width: "100%",
											background: "transparent",
											border: "1px solid #ccc",
											borderRadius: "4px",
											height: "40px",
											outline: "none",
											fontSize: "14px",
											paddingLeft: "10px",
										}}
										value={phoneNumber}
										onChange={(e) => {
											const text_value = String(e.target.value).trim();

											if (/^\d*$/.test(text_value)) {
												setPhoneNumber(text_value);
											}
											setTelefonoError(text_value.length < 7 ? true : false);
										}}
									/>
								</div>
							</div>
						</div>

						{/* Sección Derecha */}
						<div className="modal-right" style={{ flex: 1 }}>
							<div className="form-group">
								<label className="txt-name-category" htmlFor="clienteApellido">
									Apellido
								</label>
								<input
									className={`modal-input-old ${apellidoError ? "input-error" : ""}`}
									type="text"
									id="clienteApellido"
									placeholder="Ingrese el apellido"
									value={apellido}
									tabIndex={'2'}
									onChange={(e) => {
										const text_value = String(e.target.value);
										setApellido(text_value);
										setApellidoError(text_value.length > 0 && text_value.length < 2 ? true : false);
									}}
								/>
							</div>

							<div className="form-group">
								<label className="txt-name-category" htmlFor="clienteCi">
									CI / NIT
								</label>
								<input
									className={`modal-input-old ${ciError ? "input-error" : ""}`}
									type="text"
									id="clienteCi"
									placeholder="Ingrese el CI / NIT"
									tabIndex={'5'}
									onChange={(e) => {
										const text_value = String(e.target.value).trim();
										setCi(text_value);
										setCiError(text_value.length < 7 ? true : false);
									}}
								/>
							</div>
						</div>
					</div>

					<div className="modal-footer">
						<button type="button" className="cancel-button-product" onClick={onClose}>
							Cancelar
						</button>
						<button type="submit" className="save-button">
							Guardar
						</button>
					</div>
				</form>
			</div>
		</div>
	);
};
